import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($state, SmsServices) {
        this.$state = $state;
        this.SmsServices = SmsServices;
    }

    $onInit() {
        this.page = 1;
        this.acceptTerms = false;
        this.packageType = 100;
    }

    checkout() {
        this.SmsServices
            .setupExpressCheckout(this.$state.params.companyId, this.packageType)
            .then(({url}) => window.location.href = url)
            .catch((error) => this.spAlert = new SpAlert('danger', error.data.message));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/sms-purchase/sms-purchase.controller.js